import React from 'react';
import {Link} from 'react-router-dom';
import { getlanguagelist } from "../../../helpers/changelanguage";

import './PeopleYouMayKnow.css';

export default() => {
  let  languagelist = getlanguagelist();
  return (
    <div className="post_box known">
      <h3><b>{languagelist.peopleyoumayknow}</b>
        <a className="box_heading_lnk" href="#">{languagelist.seeall}</a>
      </h3>
      <ul>
        <li>
          <div className="list_ico">
            <img src="/assets/images/user.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
        <li>
          <div className="list_ico">
            <img src="/assets/images/driver.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
        <li>
          <div className="list_ico">
            <img src="/assets/images/user.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
        <li>
          <div className="list_ico">
            <img src="/assets/images/driver.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
        <li>
          <div className="list_ico">
            <img src="/assets/images/user.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
        <li>
          <div className="list_ico">
            <img src="/assets/images/driver.jpg"/></div>
          <div className="list_details">
            <h4>Bruno Gaspi</h4>
            <p className="mutual_friend">
              <img src="/assets/images/user_group.png"/> 29 {languagelist.mutualfrnd}</p>
            <a href="#" className="add_friends">
              <img src="/assets/images/add_icon.png"/></a>
          </div>
        </li>
      </ul>
    </div>
  );
};